export const RANKINGS_OVERLAY: Record<string, any> = {
  en: {
    nav: { rankings: "Rankings" },
    rankings: {
      title: "Rankings",
      subtitle: "See how you compare across your club, city, region and country.",
      verifiedTitle: "Verified matches only",
      verifiedBody: "Only Connected Matches confirmed by both players affect Elo, wins, sets and games.",
      yourRating: "Your Tennis Log Rating",
      provisional: "Provisional",
      verifiedMatches: "{{count}} verified matches",
      visibilityTitle: "Appear in rankings",
      visibilityBody: "Off by default. Turn this on to show your display name and ranking stats.",
      wins: "Wins",
      setsWon: "Sets won",
      gamesWon: "Games won",
      noClubTitle: "Add a primary club first",
      noClubBody: "Your primary club defines your club, city, region and country ranking scopes.",
      addClub: "Add club in Settings",
      scope: "Ranking area",
      scope_club: "Club",
      scope_city: "City",
      scope_region: "Region",
      scope_country: "Country",
      locationMissing: "Location not set yet",
      metric_rating: "Rating",
      metric_wins: "Wins",
      metric_sets: "Sets",
      metric_games: "Games",
      leaderboard: "Leaderboard",
      topPlayers: "Top opted-in players",
      emptyTitle: "No ranked players here yet",
      emptyBody: "Rankings will populate as players opt in and confirm Connected Matches.",
      you: "You",
      loadError: "Could not load rankings.",
      visibilityError: "Could not update ranking visibility.",
      dashboardView: "View rankings",
      dashboardClubRank: "#{{rank}} in {{club}}",
      dashboardHidden: "Hidden from rankings · turn on visibility to see your position",
      dashboardUnranked: "No club position yet · {{club}}",
      dashboardNoClub: "Add a primary club to unlock local rankings",
      wonShare: "{{value}} won",
      countedMatchesTitle: "Matches counted for ranking",
      countedMatchesBody: "These are the confirmed Connected Matches that actually contribute to your Rating, sets and games. Games in an unfinished set still count, but an unfinished set is not a set won.",
      countedMatchesLoading: "Loading ranking matches…",
      countedMatchesError: "Could not load your counted matches.",
      noCountedMatches: "No matches count towards your ranking yet. Both players must confirm a qualifying result.",
      vs: "vs",
      unknownOpponent: "Opponent",
      matchSetGames: "Sets {{setsWon}}–{{setsLost}} · Games {{gamesWon}}–{{gamesLost}}",
      matchWon: "Win",
      matchLost: "Loss",
      ratingAfter: "Rating {{value}}",
      viewMatch: "View match",
      showMoreMatches: "Show more matches"
    }
  },
  el: {
    nav: { rankings: "Κατάταξη" },
    rankings: {
      title: "Κατάταξη",
      subtitle: "Δες πώς συγκρίνεσαι σε club, πόλη, νομό/περιφέρεια και χώρα.",
      verifiedTitle: "Μόνο επιβεβαιωμένοι αγώνες",
      verifiedBody: "Μόνο Connected Matches που έχουν επιβεβαιωθεί και από τους δύο παίκτες επηρεάζουν Elo, νίκες, sets και games.",
      yourRating: "Το Tennis Log Rating σου",
      provisional: "Προσωρινό",
      verifiedMatches: "{{count}} επιβεβαιωμένοι αγώνες",
      visibilityTitle: "Εμφάνιση στην κατάταξη",
      visibilityBody: "Απενεργοποιημένο από προεπιλογή. Ενεργοποίησέ το για να εμφανίζονται το όνομα και τα ranking stats σου.",
      wins: "Νίκες",
      setsWon: "Κερδισμένα sets",
      gamesWon: "Κερδισμένα games",
      noClubTitle: "Πρόσθεσε πρώτα primary club",
      noClubBody: "Το primary club καθορίζει το club, την πόλη, την περιοχή και τη χώρα των rankings σου.",
      addClub: "Προσθήκη club στις Ρυθμίσεις",
      scope: "Περιοχή κατάταξης",
      scope_club: "Club",
      scope_city: "Πόλη",
      scope_region: "Νομός/Περιφέρεια",
      scope_country: "Χώρα",
      locationMissing: "Δεν έχει οριστεί ακόμη",
      metric_rating: "Rating",
      metric_wins: "Νίκες",
      metric_sets: "Sets",
      metric_games: "Games",
      leaderboard: "Leaderboard",
      topPlayers: "Κορυφαίοι παίκτες που έχουν επιλέξει να εμφανίζονται",
      emptyTitle: "Δεν υπάρχουν ακόμη ranked παίκτες εδώ",
      emptyBody: "Η κατάταξη θα γεμίσει καθώς οι παίκτες ενεργοποιούν την εμφάνιση και επιβεβαιώνουν Connected Matches.",
      you: "Εσύ",
      loadError: "Δεν ήταν δυνατή η φόρτωση της κατάταξης.",
      visibilityError: "Δεν ήταν δυνατή η αλλαγή της εμφάνισης στην κατάταξη.",
      dashboardView: "Προβολή κατάταξης",
      dashboardClubRank: "#{{rank}} στο {{club}}",
      dashboardHidden: "Κρυφό από την κατάταξη · ενεργοποίησε την εμφάνιση για να δεις θέση",
      dashboardUnranked: "Δεν υπάρχει ακόμη θέση στο club · {{club}}",
      dashboardNoClub: "Πρόσθεσε κύριο club για να ενεργοποιήσεις τοπικές κατατάξεις",
      wonShare: "{{value}} κερδισμένα",
      countedMatchesTitle: "Αγώνες που υπολογίζονται στην κατάταξη",
      countedMatchesBody: "Εδώ εμφανίζονται μόνο οι επιβεβαιωμένοι Connected Matches που επηρεάζουν πραγματικά το Rating, τα sets και τα games. Τα games ενός ημιτελούς set μετρούν, αλλά το ημιτελές set δεν μετρά ως κερδισμένο.",
      countedMatchesLoading: "Φόρτωση αγώνων κατάταξης…",
      countedMatchesError: "Δεν ήταν δυνατή η φόρτωση των αγώνων κατάταξης.",
      noCountedMatches: "Δεν υπάρχουν ακόμη αγώνες που υπολογίζονται. Χρειάζεται επιβεβαίωση και από τους δύο παίκτες και έγκυρο αποτέλεσμα.",
      vs: "vs",
      unknownOpponent: "Αντίπαλος",
      matchSetGames: "Sets {{setsWon}}–{{setsLost}} · Games {{gamesWon}}–{{gamesLost}}",
      matchWon: "Νίκη",
      matchLost: "Ήττα",
      ratingAfter: "Rating {{value}}",
      viewMatch: "Προβολή αγώνα",
      showMoreMatches: "Περισσότεροι αγώνες"
    }
  },
  es: {
    nav: { rankings: "Ranking" },
    rankings: {
      title: "Ranking",
      subtitle: "Compara tu nivel en tu club, ciudad, región y país.",
      verifiedTitle: "Solo partidos verificados",
      verifiedBody: "Solo los Connected Matches confirmados por ambos jugadores afectan al Elo, victorias, sets y juegos.",
      yourRating: "Tu Tennis Log Rating",
      provisional: "Provisional",
      verifiedMatches: "{{count}} partidos verificados",
      visibilityTitle: "Aparecer en rankings",
      visibilityBody: "Desactivado por defecto. Actívalo para mostrar tu nombre y estadísticas.",
      wins: "Victorias", setsWon: "Sets ganados", gamesWon: "Juegos ganados",
      noClubTitle: "Añade primero un club principal",
      noClubBody: "Tu club principal define los ámbitos de club, ciudad, región y país.",
      addClub: "Añadir club en Ajustes",
      scope: "Área del ranking", scope_club: "Club", scope_city: "Ciudad", scope_region: "Región", scope_country: "País",
      locationMissing: "Ubicación aún no definida",
      metric_rating: "Rating", metric_wins: "Victorias", metric_sets: "Sets", metric_games: "Juegos",
      leaderboard: "Clasificación", topPlayers: "Mejores jugadores participantes",
      emptyTitle: "Aún no hay jugadores clasificados aquí",
      emptyBody: "El ranking aparecerá cuando los jugadores participen y confirmen Connected Matches.",
      you: "Tú", loadError: "No se pudo cargar el ranking.", visibilityError: "No se pudo actualizar la visibilidad.",
      dashboardView: "Ver ranking",
      dashboardClubRank: "#{{rank}} en {{club}}",
      dashboardHidden: "Oculto del ranking · activa la visibilidad para ver tu posición",
      dashboardUnranked: "Aún sin posición en el club · {{club}}",
      dashboardNoClub: "Añade un club principal para activar rankings locales",
      wonShare: "{{value}} ganados",
      countedMatchesTitle: "Partidos que cuentan para el ranking",
      countedMatchesBody: "Solo aparecen los Connected Matches confirmados que cuentan para el Rating, los sets y los juegos. Los juegos de un set incompleto cuentan, pero no como set ganado.",
      countedMatchesLoading: "Cargando partidos…",
      countedMatchesError: "No se pudieron cargar los partidos del ranking.",
      noCountedMatches: "Todavía no hay partidos que cuenten. Ambos jugadores deben confirmar el resultado.",
      vs: "vs",
      unknownOpponent: "Rival",
      matchSetGames: "Sets {{setsWon}}–{{setsLost}} · Juegos {{gamesWon}}–{{gamesLost}}",
      matchWon: "Victoria",
      matchLost: "Derrota",
      ratingAfter: "Rating {{value}}",
      viewMatch: "Ver partido",
      showMoreMatches: "Mostrar más partidos"
    }
  },
  fr: {
    nav: { rankings: "Classement" },
    rankings: {
      title: "Classement",
      subtitle: "Comparez-vous dans votre club, ville, région et pays.",
      verifiedTitle: "Matchs vérifiés uniquement",
      verifiedBody: "Seuls les Connected Matches confirmés par les deux joueurs comptent pour l’Elo, les victoires, sets et jeux.",
      yourRating: "Votre Tennis Log Rating", provisional: "Provisoire", verifiedMatches: "{{count}} matchs vérifiés",
      visibilityTitle: "Apparaître au classement", visibilityBody: "Désactivé par défaut. Activez pour afficher votre nom et vos statistiques.",
      wins: "Victoires", setsWon: "Sets gagnés", gamesWon: "Jeux gagnés",
      noClubTitle: "Ajoutez d’abord un club principal", noClubBody: "Votre club principal définit les classements club, ville, région et pays.",
      addClub: "Ajouter un club dans Réglages",
      scope: "Zone de classement", scope_club: "Club", scope_city: "Ville", scope_region: "Région", scope_country: "Pays",
      locationMissing: "Localisation non définie",
      metric_rating: "Rating", metric_wins: "Victoires", metric_sets: "Sets", metric_games: "Jeux",
      leaderboard: "Classement", topPlayers: "Meilleurs joueurs participants",
      emptyTitle: "Aucun joueur classé ici pour l’instant", emptyBody: "Le classement se remplira avec les joueurs inscrits et les Connected Matches confirmés.",
      you: "Vous", loadError: "Impossible de charger le classement.", visibilityError: "Impossible de modifier la visibilité.",
      dashboardView: "Voir le classement",
      dashboardClubRank: "#{{rank}} dans {{club}}",
      dashboardHidden: "Masqué du classement · activez la visibilité pour voir votre position",
      dashboardUnranked: "Pas encore de position au club · {{club}}",
      dashboardNoClub: "Ajoutez un club principal pour activer les classements locaux",
      wonShare: "{{value}} gagnés",
      countedMatchesTitle: "Matchs pris en compte",
      countedMatchesBody: "Seuls les Connected Matches confirmés qui contribuent au Rating, aux sets et aux jeux figurent ici. Les jeux d'un set inachevé comptent, mais pas le set.",
      countedMatchesLoading: "Chargement des matchs…",
      countedMatchesError: "Impossible de charger les matchs pris en compte.",
      noCountedMatches: "Aucun match pris en compte pour le moment. Les deux joueurs doivent confirmer le résultat.",
      vs: "vs",
      unknownOpponent: "Adversaire",
      matchSetGames: "Sets {{setsWon}}–{{setsLost}} · Jeux {{gamesWon}}–{{gamesLost}}",
      matchWon: "Victoire",
      matchLost: "Défaite",
      ratingAfter: "Rating {{value}}",
      viewMatch: "Voir le match",
      showMoreMatches: "Afficher plus de matchs"
    }
  },
  de: {
    nav: { rankings: "Rangliste" },
    rankings: {
      title: "Rangliste",
      subtitle: "Vergleiche dich in Club, Stadt, Region und Land.",
      verifiedTitle: "Nur bestätigte Matches",
      verifiedBody: "Nur von beiden Spielern bestätigte Connected Matches zählen für Elo, Siege, Sets und Games.",
      yourRating: "Dein Tennis Log Rating", provisional: "Vorläufig", verifiedMatches: "{{count}} bestätigte Matches",
      visibilityTitle: "In Ranglisten erscheinen", visibilityBody: "Standardmäßig aus. Aktiviere dies, um Name und Ranking-Statistiken anzuzeigen.",
      wins: "Siege", setsWon: "Gewonnene Sets", gamesWon: "Gewonnene Games",
      noClubTitle: "Zuerst einen Hauptclub hinzufügen", noClubBody: "Dein Hauptclub bestimmt Club-, Stadt-, Regions- und Landesrangliste.",
      addClub: "Club in Einstellungen hinzufügen",
      scope: "Ranglistenbereich", scope_club: "Club", scope_city: "Stadt", scope_region: "Region", scope_country: "Land",
      locationMissing: "Ort noch nicht festgelegt",
      metric_rating: "Rating", metric_wins: "Siege", metric_sets: "Sets", metric_games: "Games",
      leaderboard: "Rangliste", topPlayers: "Beste teilnehmende Spieler",
      emptyTitle: "Noch keine gewerteten Spieler", emptyBody: "Die Rangliste füllt sich, sobald Spieler teilnehmen und Connected Matches bestätigen.",
      you: "Du", loadError: "Rangliste konnte nicht geladen werden.", visibilityError: "Sichtbarkeit konnte nicht geändert werden.",
      dashboardView: "Rangliste ansehen",
      dashboardClubRank: "#{{rank}} in {{club}}",
      dashboardHidden: "In Ranglisten verborgen · Sichtbarkeit aktivieren, um deine Position zu sehen",
      dashboardUnranked: "Noch keine Club-Position · {{club}}",
      dashboardNoClub: "Füge einen Hauptclub hinzu, um lokale Ranglisten zu aktivieren",
      wonShare: "{{value}} gewonnen",
      countedMatchesTitle: "Gewertete Matches",
      countedMatchesBody: "Hier stehen nur bestätigte Connected Matches, die Rating, Sets und Games beeinflussen. Games aus unvollständigen Sets zählen, aber das Set selbst nicht.",
      countedMatchesLoading: "Matches werden geladen…",
      countedMatchesError: "Gewertete Matches konnten nicht geladen werden.",
      noCountedMatches: "Noch keine gewerteten Matches. Beide Spieler müssen das Ergebnis bestätigen.",
      vs: "vs",
      unknownOpponent: "Gegner",
      matchSetGames: "Sets {{setsWon}}–{{setsLost}} · Games {{gamesWon}}–{{gamesLost}}",
      matchWon: "Sieg",
      matchLost: "Niederlage",
      ratingAfter: "Rating {{value}}",
      viewMatch: "Match ansehen",
      showMoreMatches: "Mehr Matches anzeigen"
    }
  },
  it: {
    nav: { rankings: "Classifica" },
    rankings: {
      title: "Classifica",
      subtitle: "Confrontati nel tuo club, città, regione e paese.",
      verifiedTitle: "Solo match verificati",
      verifiedBody: "Solo i Connected Matches confermati da entrambi i giocatori incidono su Elo, vittorie, set e game.",
      yourRating: "Il tuo Tennis Log Rating", provisional: "Provvisorio", verifiedMatches: "{{count}} match verificati",
      visibilityTitle: "Appari nelle classifiche", visibilityBody: "Disattivato di default. Attivalo per mostrare nome e statistiche.",
      wins: "Vittorie", setsWon: "Set vinti", gamesWon: "Game vinti",
      noClubTitle: "Aggiungi prima un club principale", noClubBody: "Il club principale definisce le classifiche per club, città, regione e paese.",
      addClub: "Aggiungi club nelle Impostazioni",
      scope: "Area classifica", scope_club: "Club", scope_city: "Città", scope_region: "Regione", scope_country: "Paese",
      locationMissing: "Posizione non ancora definita",
      metric_rating: "Rating", metric_wins: "Vittorie", metric_sets: "Set", metric_games: "Game",
      leaderboard: "Classifica", topPlayers: "Migliori giocatori partecipanti",
      emptyTitle: "Nessun giocatore classificato qui", emptyBody: "La classifica si popolerà con opt-in e Connected Matches confermati.",
      you: "Tu", loadError: "Impossibile caricare la classifica.", visibilityError: "Impossibile aggiornare la visibilità.",
      dashboardView: "Vedi classifica",
      dashboardClubRank: "#{{rank}} in {{club}}",
      dashboardHidden: "Nascosto dalle classifiche · attiva la visibilità per vedere la posizione",
      dashboardUnranked: "Nessuna posizione nel club · {{club}}",
      dashboardNoClub: "Aggiungi un club principale per attivare le classifiche locali",
      wonShare: "{{value}} vinti",
      countedMatchesTitle: "Match validi per la classifica",
      countedMatchesBody: "Solo i Connected Matches confermati che incidono su Rating, set e game sono inclusi. I game di un set incompleto contano, ma il set non è vinto.",
      countedMatchesLoading: "Caricamento dei match…",
      countedMatchesError: "Impossibile caricare i match validi.",
      noCountedMatches: "Nessun match valido per la classifica. Entrambi i giocatori devono confermare il risultato.",
      vs: "vs",
      unknownOpponent: "Avversario",
      matchSetGames: "Set {{setsWon}}–{{setsLost}} · Game {{gamesWon}}–{{gamesLost}}",
      matchWon: "Vittoria",
      matchLost: "Sconfitta",
      ratingAfter: "Rating {{value}}",
      viewMatch: "Vedi match",
      showMoreMatches: "Mostra altri match"
    }
  },
  ja: {
    nav: { rankings: "ランキング" },
    rankings: {
      title: "ランキング",
      subtitle: "クラブ・都市・地域・国ごとに自分の順位を確認できます。",
      verifiedTitle: "確認済み試合のみ",
      verifiedBody: "両選手が確認した Connected Match のみが Elo、勝利数、セット数、ゲーム数に反映されます。",
      yourRating: "Tennis Log Rating", provisional: "暫定", verifiedMatches: "確認済み {{count}} 試合",
      visibilityTitle: "ランキングに表示", visibilityBody: "初期設定はオフです。オンにすると表示名とランキング成績が表示されます。",
      wins: "勝利", setsWon: "獲得セット", gamesWon: "獲得ゲーム",
      noClubTitle: "まずメインクラブを追加してください", noClubBody: "メインクラブからクラブ・都市・地域・国のランキング範囲を決定します。",
      addClub: "設定でクラブを追加",
      scope: "ランキング範囲", scope_club: "クラブ", scope_city: "都市", scope_region: "地域", scope_country: "国",
      locationMissing: "場所が未設定です",
      metric_rating: "Rating", metric_wins: "勝利", metric_sets: "セット", metric_games: "ゲーム",
      leaderboard: "ランキング", topPlayers: "参加選手の上位",
      emptyTitle: "まだランキング対象の選手がいません", emptyBody: "選手が表示を有効にし、Connected Match を確認すると順位が表示されます。",
      you: "あなた", loadError: "ランキングを読み込めませんでした。", visibilityError: "表示設定を更新できませんでした。",
      dashboardView: "ランキングを見る",
      dashboardClubRank: "{{club}}で #{{rank}}",
      dashboardHidden: "ランキング非表示 · 表示をオンにすると順位を確認できます",
      dashboardUnranked: "クラブ順位はまだありません · {{club}}",
      dashboardNoClub: "メインクラブを追加すると地域ランキングを利用できます",
      wonShare: "{{value}} 獲得",
      countedMatchesTitle: "ランキング対象の試合",
      countedMatchesBody: "両選手が確認した Connected Match のうち、Rating・セット・ゲームに反映された試合のみを表示します。未完了セットのゲームは集計しますが、セット勝利には含みません。",
      countedMatchesLoading: "試合を読み込み中…",
      countedMatchesError: "対象試合を読み込めませんでした。",
      noCountedMatches: "対象試合はまだありません。両選手の結果確認が必要です。",
      vs: "vs",
      unknownOpponent: "対戦相手",
      matchSetGames: "セット {{setsWon}}–{{setsLost}} · ゲーム {{gamesWon}}–{{gamesLost}}",
      matchWon: "勝利",
      matchLost: "敗北",
      ratingAfter: "Rating {{value}}",
      viewMatch: "試合を見る",
      showMoreMatches: "さらに試合を表示"
    }
  }
};
